import { useState } from "react";
import { triggerSync } from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export function SyncButton() {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      const res = await triggerSync();
      const b = res.beliefs || {};
      const s = res.stories || {};
      toast.success(
        `Synced. Beliefs: +${b.inserted || 0} new, ${b.updated || 0} updated · Stories: +${s.inserted || 0} new, ${s.updated || 0} updated`,
      );
      // simple way to refresh data on current page
      window.dispatchEvent(new CustomEvent("indielaw:sync-complete"));
    } catch (e) {
      toast.error(`Sync failed: ${e?.response?.data?.detail || e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={loading}
      data-testid="sync-now-button"
      className="ml-4 inline-flex items-center gap-2 bg-[#FFD100] text-[#141B4D] px-4 py-2 rounded-sm text-sm font-bold hover:bg-[#e6bd00] transition-colors disabled:opacity-60"
    >
      <RefreshCw
        size={14}
        className={loading ? "animate-spin" : ""}
        strokeWidth={2.5}
      />
      {loading ? "Syncing…" : "Sync Now"}
    </button>
  );
}
